import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login h-full" }
const _hoisted_2 = { class: "grid grid-cols-9 place-content-center h-full" }
const _hoisted_3 = { class: "col-span-9 md:col-start-3 md:col-span-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-xl font-medium mb-1" }, "Login", -1)
const _hoisted_5 = { class: "onboarding-card shadow-md" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex justify-center" }
const _hoisted_10 = { class: "flex justify-center w-full m-3" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "rounded-md space-y-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "email-address",
  class: "onboarding-label"
}, "Email address", -1)
const _hoisted_14 = { class: "error-msg" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "onboarding-label"
}, "Password", -1)
const _hoisted_16 = { class: "error-msg" }
const _hoisted_17 = { class: "mr-3 underline text-blue-500" }
const _hoisted_18 = {
  key: 1,
  class: "error-msg"
}
const _hoisted_19 = { class: "flex flex-col items-baseline space-x-2" }
const _hoisted_20 = { class: "flex justify-between w-full" }
const _hoisted_21 = { class: "register-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyInfoForm = _resolveComponent("CompanyInfoForm")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_GoogleSignInButton = _resolveComponent("GoogleSignInButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ReCaptchaV2 = _resolveComponent("ReCaptchaV2")!
  const _component_LoadingButton = _resolveComponent("LoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.requestCompanyDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_CompanyInfoForm, {
                  companyData: _ctx.companyData,
                  onCompanySubmitted: _ctx.companySubmitted,
                  loading: _ctx.loading||_ctx.googleLoading
                }, null, 8, ["companyData", "onCompanySubmitted", "loading"]),
                (_ctx.responseError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.responseError), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.googleLoading||_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_Loader, {
                        key: 0,
                        class: "h-[50px]",
                        color: "black"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_GoogleSignInButton, { onToken: _ctx.tokenReceived }, null, 8, ["onToken"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("form", {
                    class: "space-y-4",
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loginSubmitted && _ctx.loginSubmitted(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("input", {
                          id: "email-address",
                          name: "email",
                          type: "email",
                          autocomplete: "email",
                          required: "true",
                          class: "text-input",
                          placeholder: "Email address",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.email]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-errors",
                            key: error.$uid
                          }, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(error.$message), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("input", {
                          id: "password",
                          name: "password",
                          type: "password",
                          autocomplete: "current-password",
                          required: "true",
                          class: "text-input",
                          placeholder: "Password",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.password]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.password.$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-errors",
                            key: error.$uid
                          }, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(error.$message), 1)
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_router_link, { to: "/forgot" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Forgot password?")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (!_ctx.requestCompanyDetails)
                        ? (_openBlock(), _createBlock(_component_ReCaptchaV2, {
                            key: 0,
                            onToken: _ctx.tokenReceived
                          }, null, 8, ["onToken"]))
                        : _createCommentVNode("", true),
                      (_ctx.responseError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.responseError), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_LoadingButton, {
                            disabled: _ctx.v$.$invalid,
                            loading: _ctx.loading
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Log In")
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_router_link, { to: "/register" }, {
                            default: _withCtx(() => [
                              _createTextVNode("New? Create an account")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ], 32)
                ])
              ]))
        ])
      ])
    ])
  ]))
}